import React from "react";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";
import SettingsField from "../fields/SettingsField";
import ProfileCard from "../profile/ProfileCard";

export default function ProfileSection({ 
  form, 
  onChange, 
  markDirty, 
  onShowChangePassword
}) {
  return (
    <SettingsSection
      id="profile-account"
      title="Profile & Account"
      icon={<UserCircleIcon className="h-5 w-5 text-primary" />}
    >
      <ProfileCard 
        form={form} 
        onChange={onChange}
        onShowChangePassword={onShowChangePassword}
      />
      
      <SettingsField
        label="Display name"
        htmlFor="displayName"
        description="This name appears on your public notes and profile."
        required
      >
        <input
          id="displayName"
          type="text"
          value={form.displayName}
          onChange={(e) => onChange("displayName", e.target.value)}
          onInput={markDirty}
          placeholder="Your name"
          className="w-full bg-surface-elevated rounded-lg border border-border-strong px-3 py-2 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-indigo-600"
        />
      </SettingsField>
    </SettingsSection>
  );
}
